/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions'

const { resetExternalPaymentStatus } = createActions({
  RESET_EXTERNAL_PAYMENT_STATUS: () => {}
})

export { resetExternalPaymentStatus }
